import React, { useContext } from 'react';
import { Icon, Container, Button, Message, Divider, Card, List } from 'semantic-ui-react';
import API, { ResponseManagement } from './../../API';
import PanierItem from './PanierItem';
import './Panier.css';
import PanierContext from './../../contexts/PanierContext';
import GlobalContext from './../../contexts/GlobalContext';
import Utility from './../../Utility';
import AmountProvider from './../Provider/AmountProvider';

/**
 * 
 * @param {panierMobile, panierState} props 
 */
function Panier(props) {
  const [globalContext] = useContext(GlobalContext);
  const [panierContext, panierDispatch] = useContext(PanierContext);

  const addSupplements = (ev, el, folder) => {
    let tabToSend = [];
    const folderId = folder.folderId;

    ev.persist();
    ev.currentTarget.classList.add('loading', 'disabled');

    if (folder.bookings && folder.bookings.length > 0) {
      folder.bookings.forEach(booking => {
        if (booking.supplements && booking.supplements.length > 0) {
          booking.supplements.forEach(supplement => {
            tabToSend.push(
              {
                bookingFolderId: folderId,
                bookingId: supplement.bookingId,
                serviceId: supplement.id,
                serviceType: supplement.type,
                quantity: supplement.quantity
              }
            )
          })
        }
      })

      if (tabToSend.length > 0) {
        //loader
        API.post(Utility.getUrlAjax() + '/updateBookingServiceAction', JSON.stringify({ data: tabToSend }))
        .then(response => {
          ResponseManagement(response,
            () => {
              if (response.data.success) {
                // TODO: a modifier
                panierDispatch({ type: "PAY", payload: tabToSend, folderId: folderId })
                window.location.reload()
              }
            },
            () => {
              console.warn(response)
            }
          )
        })
        .catch(error => {
          console.error(error)
        })
      }
    }
  }

  const getOrdersContent = () => {
    let tab = [];
    if(panierContext) {
      if (panierContext.orders && panierContext.orders.length > 0) {
        panierContext.orders.forEach(folder => {
          tab.push(
            <Card key={folder.folderId} style={{ width: '100%' }} className="mb-4">
              <Card.Content className="panier-header" header={`${globalContext.translations.preCheckInBookingNumber} N° ${folder.folderNumber}`} />
              <Card.Content description={getBookings(folder.bookings, folder.folderId)} />
              <Card.Content extra>
                <div style={{marginBottom : '10px'}}>
                  {globalContext.translations.payToHotel}
                </div>
                <div style={{ alignItems: 'center' }} className="d-flex justify-content-between">
                  <div>
                    <span className="font-weight-bold">{globalContext.translations.totalPayable}: </span><span className="text-primary font-weight-bold" style={{ fontSize: '1.2em' }}><AmountProvider amount={getTotalPanier(folder.folderId)} currency={folder.currency} /></span>
                  </div>
                  <div>
                    <Button
                      onClick={(ev, el) => addSupplements(ev, el, folder)}
                      primary>
                      {globalContext.translations.pay}
                      <Icon className="pl-3" name="check" />
                    </Button>
                  </div>
                </div>
              </Card.Content>
            </Card>
          )
        })
      } else {
        return (
          <Message
            header={globalContext.translations.emptyBasket}
            content={globalContext.translations.addSupplementsToContinue}
          />
        )
      }
    } else {
      return (
        <Message
          header={globalContext.translations.emptyBasket}
          content={globalContext.translations.addSupplementsToContinue}
        />
      )
    }


    return tab;
  }

  const getBookings = (bookings, folderId) => {
    let tab = [];
    if (bookings && bookings.length > 0) {
      bookings.forEach(booking => {
        tab.push(
          <div className="mb-4" key={booking.bookingId}>
            <div className="mb-3" style={{ textAlign: 'left' }}>
              <h5>{`${globalContext.translations.accommodation} N°${booking.bookingId}`}</h5>
              <Divider />
            </div>
            <List
               divided
               className={props.panierMobile ? '' : 'pl-4'}
               verticalAlign="middle"
            >
              {getSupplements(booking.supplements, folderId, booking.bookingId)}
            </List>
          </div>
        )
      })
    }

    return tab;
  }

  const getSupplements = (supplements, folderId, bookingId) => {
    let tab = [];
    let i = 0;
    if (supplements && supplements.length > 0) {
      supplements.forEach(supplement => {
        i++;
        tab.push(
          <List.Item key={supplement.id}>
            <List.Content content={
              <div>
                <PanierItem item={supplement} folderId={folderId} bookingId={bookingId} supplements={supplements} />
                {i !== supplements.length ? <Divider /> : null}
              </div>
            } />
          </List.Item>
        )
      })
    }

    return tab;
  }

  const getTotalPanier = (folderId) => {
    let totalPanier = 0;
    if (panierContext.orders.length > 0) {
      panierContext.orders.forEach(order => {
        if (order.folderId === folderId) {
          order.bookings.forEach(booking => {
            booking.supplements.forEach(suppl => {
              totalPanier += parseFloat(suppl.panierTotalPrice);
            })
          });
        }
      });
    }

    return totalPanier;
  }

  return (
    <Container className={props.panierMobile ? 'p-5 mt-5' : 'p-5' }>
      <div className="mt-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h3><Icon name={Utility.getIconPage('panier')} />{globalContext.translations.myBasket}</h3>
        </div>
      </div>
      <Divider />
      <div>
        {getOrdersContent()}
      </div>
    </Container>
  )
}

export default Panier;